
import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface ServiceItemProps {
  title: string;
  description: string;
  defaultOpen?: boolean;
}

const ServiceAccordion = () => {
  const services = [
    {
      title: "Operational Efficiency & Process Improvement",
      description: "I streamline workflows and eliminate bottlenecks, boosting productivity through standardized processes and smart automation. My practical solutions ensure your business grows smoothly, without the headaches of disorganized operations."
    },
    {
      title: "Leadership & Team Development",
      description: "I equip leaders with the confidence, clarity, and accountability needed to drive results. Through tailored training, I strengthen team communication, enhance collaboration, and build a high-performance culture that retains top talent."
    },
    {
      title: "Strategic Growth & Scaling",
      description: "I help business owners define and execute clear, sustainable growth strategies aligned with their vision. By optimizing processes, teams, and market positioning, I ensure your business scales efficiently and profitably, reducing risk and boosting confidence."
    },
    {
      title: "Decision-Making & Data-Driven Strategy",
      description: "I transform data into clear, actionable insights, guiding business owners to make smarter, informed decisions. By analyzing KPIs, financial trends, and operational metrics, I help leaders drive efficiency, profitability, and sustainable success."
    }
  ];

  return (
    <Accordion type="single" collapsible className="w-full">
      {services.map((service, index) => (
        <AccordionItem key={index} value={`item-${index}`} className="border-b border-maroon/20">
          <AccordionTrigger className="text-xl font-heading text-charcoal hover:text-maroon py-5 text-left flex justify-between">
            <span className="text-left pr-4">{service.title}</span>
          </AccordionTrigger>
          <AccordionContent className="text-charcoal-light text-lg pb-6">
            {service.description}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default ServiceAccordion;
